import React, {useLayoutEffect} from 'react';
import {App as AntdApp, message as staticMessage} from 'antd';

let messageApi = null;

/** antd 5: static message.* ignores ConfigProvider theme; use instance from <App> when mounted. */
export function getAntdMessage() {
  return messageApi || staticMessage;
}

export function AntdAppMessageBinder() {
  const {message} = AntdApp.useApp();
  useLayoutEffect(() => {
    messageApi = message;
    return () => {
      messageApi = null;
    };
  }, [message]);
  return null;
}
